import { SUBTYPE_DP_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useSubtypeDPListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${SUBTYPE_DP_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
